(() => {
  const root = document.documentElement;
  root.classList.add('ate-quiet-chat', 'ate-quiet-discount');
  let panelId = 0;
  let scheduled = false;
  function refineWidgets() {
    scheduled = false;
    document.querySelectorAll('.chp_prod_star_rating_wrapper, .chp_single_product_rating_preview').forEach(el => {
      const empty = /^0\s+reviews?$/i.test(el.textContent.trim());
      el.classList.toggle('ate-zero-rating', empty);
    });
    document.querySelectorAll('.product_reviews_wrapper').forEach(el => {
      const count = el.querySelector('.total_reviews');
      el.classList.toggle('ate-reviews-empty', !!count && /^0\s+reviews?$/i.test(count.textContent.trim()));
    });
    document.querySelectorAll('.pt-tab-btn').forEach(button => {
      const panel = button.nextElementSibling;
      if (!panel?.classList.contains('pt-panel')) return;
      if (!panel.id) panel.id = `AteProductPanel-${++panelId}`;
      if (!button.id) button.id = `${panel.id}-button`;
      button.type = 'button';
      button.setAttribute('aria-controls', panel.id);
      const expanded = button.classList.contains('active');
      button.setAttribute('aria-expanded', String(expanded));
      panel.setAttribute('role', 'region');
      panel.setAttribute('aria-labelledby', button.id);
      panel.inert = !expanded;
    });
    const chatButton = document.getElementById('id_instachat_float_widget_button');
    if (chatButton && !chatButton.getAttribute('aria-label')) chatButton.setAttribute('aria-label', document.body.dataset.ateChatLabel);
    document.querySelectorAll('.ecomsend__Popover__Widget').forEach(widget => {
      widget.setAttribute('role', 'button');
      widget.setAttribute('tabindex', '0');
      widget.setAttribute('aria-label', widget.textContent.trim());
    });
    if (root.classList.contains('ate-quiet-discount')) {
      document.querySelectorAll('.ecomsend__Modal__CloseButton').forEach(button => button.click());
    }
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(refineWidgets);
  }
  document.addEventListener('click', event => {
    if (event.target.closest('#id_instachat_float_widget_button')) root.classList.remove('ate-quiet-chat');
    if (event.target.closest('.ecomsend__Popover__Widget')) root.classList.remove('ate-quiet-discount');
    if (event.target.closest('.pt-tab-btn')) schedule();
  }, true);
  document.addEventListener('keydown', event => {
    const widget = event.target.closest('.ecomsend__Popover__Widget');
    if (widget && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      widget.click();
    }
  });
  const observer = new MutationObserver(schedule);
  observer.observe(document.body, {childList:true, subtree:true, attributes:true, attributeFilter:['class'], characterData:true});
  refineWidgets();
})();

// Keep app-generated thumbnails and selected images aligned with reviewed mockups.
(() => {
  const main = document.getElementById('MainContent');
  if (!main) return;
  const reviewedImages = {
  "10462379022256870755_v2_2048_custom.jpg": "https://cdn.shopify.com/s/files/1/0925/8198/6603/files/ate-professional-black-t-shirt-20261002.png?v=1790976849",
  "3694924846470579838_v2_2048_custom.jpg": "https://cdn.shopify.com/s/files/1/0925/8198/6603/files/ate-professional-aqua-t-shirt-20261002.png?v=1790976854",
  "10617000968850061908_2048.jpg": "https://cdn.shopify.com/s/files/1/0925/8198/6603/files/ate-professional-black-hoodie-20261002.png?v=1790976859",
  "rn-image_picker_lib_temp_57986bcb-3976-4cbd-9198-f3a43a1f6fb2.png": "https://cdn.shopify.com/s/files/1/0925/8198/6603/files/ate-professional-long-sleeve-20261002.png?v=1790976863",
  "12565760302739197719_2048.jpg": "https://cdn.shopify.com/s/files/1/0925/8198/6603/files/ate-professional-white-onesie-20261002.png?v=1790976867",
  "4707891445634201142_2048.jpg": "https://cdn.shopify.com/s/files/1/0925/8198/6603/files/ate-professional-heather-onesie-20261002.png?v=1790977999",
  "rn-image_picker_lib_temp_e249923d-cc8d-46e4-bda7-99cbbae65a28.png": "https://cdn.shopify.com/s/files/1/0925/8198/6603/files/ate-professional-white-long-sleeve-20261002.png?v=1790978004",
  "10369819526065040203_2048.jpg": "https://cdn.shopify.com/s/files/1/0925/8198/6603/files/ate-professional-navy-hoodie-20261002.png?v=1790978007"
};
  const reviewedAltText = {
  "ate-professional-black-t-shirt-20261002.png": "Black customizable T-shirt with clean Your Design Here placeholder",
  "ate-professional-aqua-t-shirt-20261002.png": "Aqua customizable T-shirt with clean Your Design Here placeholder",
  "ate-professional-black-hoodie-20261002.png": "Black customizable pullover hoodie with clean Your Design Here placeholder",
  "ate-professional-long-sleeve-20261002.png": "Black customizable long-sleeve shirt with clean Your Design Here placeholder",
  "ate-professional-white-onesie-20261002.png": "White customizable baby onesie with clean Your Design Here placeholder",
  "ate-professional-heather-onesie-20261002.png": "Athletic Heather gray customizable baby onesie with clean Your Design Here placeholder",
  "ate-professional-white-long-sleeve-20261002.png": "White customizable long-sleeve shirt with clean Your Design Here placeholder",
  "ate-professional-navy-hoodie-20261002.png": "Navy customizable pullover hoodie with clean Your Design Here placeholder"
};
  function reviewedUrl(source) {
    try {
      const original = new URL(source, document.baseURI);
      const filename = decodeURIComponent(original.pathname.split('/').pop())
        .replace(/_(?:\d+x\d*|x\d+)(?=\.(?:png|jpe?g|webp)$)/i, '');
      if (!Object.prototype.hasOwnProperty.call(reviewedImages, filename)) return source;
      const replacement = new URL(reviewedImages[filename]);
      for (const key of ['width', 'height', 'crop']) {
        if (original.searchParams.has(key)) replacement.searchParams.set(key, original.searchParams.get(key));
      }
      return replacement.href;
    } catch {
      return source;
    }
  }
  function refineApparelImages() {
    scheduled = false;
    main.querySelectorAll('img[src], img[srcset]').forEach(image => {
      for (const attribute of ['src', 'srcset']) {
        const source = image.getAttribute(attribute);
        if (!source) continue;
        const replacement = attribute === 'src' ? reviewedUrl(source)
          : source.replace(/(?:https?:)?\/\/[^\s,]+/g, reviewedUrl);
        if (replacement !== source) {
          image.setAttribute(attribute, replacement);
          if (attribute === 'src') {
            const filename = new URL(replacement, document.baseURI).pathname.split('/').pop();
            if (reviewedAltText[filename]) image.alt = reviewedAltText[filename];
          }
        }
      }
    });
    main.querySelectorAll('.bcpo-front-image-label').forEach(label => {
      const input = document.getElementById(label.htmlFor);
      if (input?.value) {
        if (!input.hasAttribute('aria-label')) input.setAttribute('aria-label', input.value);
        if (!label.title) label.title = input.value;
      }
      const source = label.style.backgroundImage;
      const replacement = source.replace(/url\(["']?([^"')]+)["']?\)/g, (_, url) => 'url("' + reviewedUrl(url) + '")');
      if (replacement !== source) label.style.backgroundImage = replacement;
    });
  }
  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(refineApparelImages);
  });
  observer.observe(main, {childList:true, subtree:true, attributes:true, attributeFilter:['style', 'src', 'srcset']});
  refineApparelImages();
})();
